import React from 'react';

import ClearIcon from 'ravenjs/lib/SvgIcon/types/ClearIcon';
import { Toaster as DefaultToaster } from 'ravenjs/lib/Toaster';

import { DEFAULT_COLORS } from 'constants/colors';

const commonStyles = {
    color: DEFAULT_COLORS.BLACK,
    margin: '10px',
    minHeight: '48px',
    borderRadius: '6px',
    boxShadow: '0 2px 6px 0 rgba(223, 223, 223, 0.5)',
    backgroundColor: DEFAULT_COLORS.WHITE,
    border: `solid 1px ${DEFAULT_COLORS.LIGHTER}`,
};
const defaultStyles = {
    borderLeft: `solid 16px ${DEFAULT_COLORS.GREEN}`,
};
const errorStyles = {
    borderLeft: `solid 16px ${DEFAULT_COLORS.RED}`,
};
const successStyles = {
    borderLeft: `solid 16px ${DEFAULT_COLORS.GREEN}`,
};
const warningStyles = {
    borderLeft: `solid 16px ${DEFAULT_COLORS.ORANGE}`,
};

const Toaster = props => {
    const closeButton = ({ closeToast }) => <ClearIcon margin="auto 0.5rem" onClick={closeToast} />;

    return (
        <DefaultToaster
            closeButton={closeButton}
            closeOnClick={false}
            commonStyles={commonStyles}
            errorStyles={errorStyles}
            successStyles={successStyles}
            warningStyles={warningStyles}
            defaultStyles={defaultStyles}
            position="bottom-left"
            {...props}
        />
    );
};

export default Toaster;
